import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductFeatures } from './components/ProductFeatures';
import { BonusSection } from './components/BonusSection';
import { PricingOffer } from './components/PricingOffer';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
      (window as any).fbq('init', '1490690799317548');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1490690799317548&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <StickyAlertBar data-id="element-3" />

      <main className="flex-grow" data-id="element-4">
        <HeroSection data-id="element-5" />

        <PainPointsSection data-id="element-6" />
        
        <ProductFeatures data-id="element-7" />
        
        <BonusSection data-id="element-8" />
        <div className="section-divider" data-id="element-9"></div>
        <PricingOffer data-id="element-10" />
        <div className="section-divider" data-id="element-11"></div>
        <Testimonials data-id="element-12" />
        <div className="section-divider" data-id="element-13"></div>
        <FAQ data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}